import {createApp} from 'vue'
import options from './DonationAmountPicker.options'

const el = '.kb-component--donation-amount-picker'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((DonationAmountPickerDOM)=>{
            const template = DonationAmountPickerDOM.outerHTML
            options.template = template
            const component = createApp(options).use(Store)
            component.mount(DonationAmountPickerDOM)
        })
    }
}

